module.exports = __webpack_public_path__ + "img/text.3dc84960.png";